import React from 'react';
import { motion } from 'framer-motion';

const MarqueeText = ({ text, speed = 50, direction = 'left' }) => {
  const duplicatedText = Array(10).fill(text).join('   •   ');

  return (
    <div className="relative overflow-hidden py-8 border-y border-gray-800">
      <motion.div
        animate={{
          x: direction === 'left' ? ['0%', '-50%'] : ['-50%', '0%']
        }}
        transition={{
          duration: speed,
          repeat: Infinity,
          ease: 'linear'
        }}
        className="flex whitespace-nowrap"
      >
        <span className="text-4xl md:text-6xl font-bold text-transparent text-stroke tracking-wider">
          {duplicatedText}
        </span>
        <span className="text-4xl md:text-6xl font-bold text-transparent text-stroke tracking-wider">
          {duplicatedText}
        </span>
      </motion.div>
    </div>
  );
};

const MarqueeSection = () => {
  return (
    <section className="bg-[#0f0f0f] relative overflow-hidden">
      <MarqueeText text="DESIGN" speed={30} direction="left" />
      <MarqueeText text="DEVELOP" speed={40} direction="right" />
      <MarqueeText text="INNOVATE" speed={35} direction="left" />
    </section>
  );
};

export default MarqueeSection;